import { connect } from 'react-redux'

import DeleteCustomFieldView from './DeleteCustomFieldView.jsx';
import { deleteCustomField } from 'src/legacy/redux/actions/customFields.jsx';


const mapStateToProps = (state, ownProps) => {
  return {
    customFields: state.legacyRootReducer.settings.customFields.items,
    deleting: state.legacyRootReducer.settings.customFields.deleting
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteCustomField: (id) => {
      return dispatch(deleteCustomField(id));
    }
  }
}

const DeleteCustomFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteCustomFieldView)

export default DeleteCustomFieldContainer;